
import { Vue, Component, Ref } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import DataEditorDialog from "@/components/helpers/data/editor-dialog.vue";
import { mdiDownload, mdiPlus } from "@mdi/js";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { Filter } from "@/cms-services/filter";
import axios from "axios";
@Component({
  components: { DataEditorDialog },
})
export default class EventList extends Vue {
  @Ref("editor") editor!: DataEditorDialog;
  icons: any = {
    download: mdiDownload,
    plus: mdiPlus,
  };

  headers: any = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: true,
    },
    {
      text: "ФИО",
      value: "fullName",
      sortable: true,
    },
    {
      text: "Телефон",
      value: "phone",
      sortable: false,
    },
    {
      text: "Почта",
      value: "email",
      sortable: false,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  profileDataSource: ListDataSource = new ListDataSource({
    className: "profile",
    config: {
      pageIndex: 1,
      pageSize: 3000,
    },
  });

  fields: any = [
    {
      editor: "auto-complete-select",
      attrs: {
        type: "text",
        outlined: true,
        label: "Выберите пользователя",
        noDataText: "Данные не найдены",
      },
      name: "profileId",
      config: {
        getItems: "getProfiles",
        labelKeyName: "fullName",
        valueKeyName: "id",
        type: "select",
      },
    },
  ];

  eventObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.eventId,
    config: {},
    className: "event",
  });

  actions: any = {
    getProfiles: () => this.profileDataSource.items,
  };

  model: any = {
    eventId: +this.$route.params.eventId,
    profileId: null,
  };

  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
      filter: [
        new Filter("eventId", +this.$route.params.eventId),
      ].toFilterString(),
    },
    className: "EventRegistration",
  });
  loaded: boolean = false;
  $message: any;

  get breadcrumbs() {
    // Открыто из урока здоровья (masterclasses/id.vue) — назад к уроку, а не в раздел событий
    const fromLesson = this.$route.query.from === "masterclass";
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: fromLesson ? "Мастер-классы" : "События",
        to: fromLesson ? "/manage/masterclass/" : "/manage/events/",
        exact: true,
      },
      {
        text: this.eventObjectDataSource.model?.caption,
        to: fromLesson
          ? `/manage/masterclass/${this.$route.params.eventId}`
          : `/manage/events/${this.$route.params.eventId}`,
        exact: true,
      },
      {
        text: "Регистрация",
        disabled: true,
      },
    ];
  }

  async created() {
    await this.eventObjectDataSource.get();
    await this.profileDataSource.get();
    this.loaded = true;
  }

  public async downloadExcel() {
    try {
      const { data } = await axios.get(`/manage/eventregistration/event/${+this.$route.params.eventId}/download/xlsx`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.download = "Список пользователей.xlsx";
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      throw error;
    }
  }

  async add() {
    const model: any = await this.editor.update(this.model);
    if (!model) return;

    await this.dataSource.add(model);
    this.$message("Успешно добавлено");
  }
}
